import { useMutation, useQuery } from '@tanstack/react-query'
import { apiClient } from '../api/client'

export interface Match {
  id: string
  userId: string
  name: string
  avatar?: string
  /** Ссылка на профиль собеседника в MAX, если при входе был известен username. */
  maxProfileUrl?: string | null
  lastMessageAt?: string
}

export interface MatchDetail {
  id: string
  userId: string
  name?: string
  maxProfileUrl?: string | null
  maxAvatarUrl?: string | null
  profile?: {
    name?: string
    photos?: Array<{ url: string; thumbUrl?: string }>
  }
}

export function useMatches() {
  return useQuery({
    queryKey: ['matches'],
    queryFn: () => apiClient.get<Match[]>('/api/matches'),
  })
}

export function useMatch(matchId: string) {
  return useQuery({
    queryKey: ['match', matchId],
    queryFn: () => apiClient.get<MatchDetail>(`/api/matches/${matchId}`),
  })
}

export function useUnmatch() {
  return useMutation({
    mutationFn: (matchId: string) => apiClient.post(`/api/matches/${matchId}/unmatch`),
  })
}
